import useMediaQuery from '@mui/material/useMediaQuery';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/useMediaQuery": useMediaQuery } } });
export default ClientProvider;
